import React, { useEffect, useState } from "react";
import { Alert, Container } from "reactstrap";
import { showTopbarInsideAction } from "../../../store/actions";
import { useDispatch } from "react-redux";
import HeaderDefaultToPage from "../../../components/Common/headerDefaultToPage";
import InputSearch from "../../../components/Inputs/InputSearch";
import { Link } from "react-router-dom";

const NO006 = () => {
  document.title = "Defender | Minhas Empresas";

  const dispatch = useDispatch();
  const [messageAlert, setmessageAlert] = useState(null);

  const handleButton = (idDevice) => {
    setmessageAlert({message: "Pendente implantação do backend.", color: "warning"})
  };

  const handleSubmit= (e) => {
    e.preventDefault()

    setmessageAlert({message: "Pendente implantação do backend.", color: "warning"})
  }

  useEffect(() => {
    dispatch(showTopbarInsideAction({}));
  }, []);

  return (
    <React.Fragment>
      <div className="page-content page-config">
        <Container fluid={true} className="dataTable-custom-primary">
          <HeaderDefaultToPage
            title={"Minhas Empresas"}
          />
          <div className="row content-page my-4">
            <div className="col-lg-4 col-md-5 col-12">
              <div className="bg-white card-content w-100">
                <div className="card-body">
                  <div className="d-flex align-items-center gap-3">
                    <span className="m-0 font-size-16 font-w-600 text-black">
                      Empresas
                    </span>
                    <div className="bg-gray dot-divider"></div>
                    <span className="m-0 font-size-16 font-w-400 text-black">01</span>
                  </div>
                  <div className="d-flex mt-3 mb-2">
                    <InputSearch 
                      width={"100%"} 
                      height={54} 
                      sizeIcon={24} 
                      placeholder="Busca"
                      inputFontSize={16}
                      onChange={(e) => console.log(e)}
                    /> 
                  </div>
                  <div className="d-flex ">
                    <ul className="ul-list-custom w-100">
                      <li style={{height: 64}} className="px-0 mb-3">
                        <Link
                          className="d-flex align-items-center justify-content-between"
                        >
                          <div className="d-flex align-items-center gap-2">
                            <div style={{width: 48, height: 48}} className="bg-info rounded-circle"></div>
                            <span>Carajas</span>
                          </div>
                          <i class="fas fa-chevron-right font-size-24 mt-1"></i>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default NO006;
